import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../config/firebase';
import { signOut } from 'firebase/auth';

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/listings', label: 'Listings', icon: '🏡' },
    { path: '/profile', label: 'Profile', icon: '👤' },
  ];

  return (
    <div style={styles.nav}>
      {tabs.map(tab => (
        <div
          key={tab.path}
          style={{
            ...styles.tab,
            ...(location.pathname === tab.path ? styles.activeTab : {})
          }}
          onClick={() => navigate(tab.path)}
        >
          <span style={styles.icon}>{tab.icon}</span>
          <span style={{
            ...styles.label,
            color: location.pathname === tab.path ? '#2E86AB' : '#999'
          }}>{tab.label}</span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  nav: {
    position: 'fixed', bottom: 0, left: 0, right: 0,
    background: '#fff', borderTop: '1px solid #eee',
    display: 'flex', justifyContent: 'space-around',
    padding: '8px 0 16px', zIndex: 1000,
    boxShadow: '0 -2px 10px rgba(0,0,0,0.06)'
  },
  tab: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    cursor: 'pointer', padding: '4px 20px', borderRadius: 8
  },
  activeTab: {
    background: '#f0f8ff'
  },
  icon: { fontSize: 22, marginBottom: 2 },
  label: { fontSize: 11, fontWeight: '600' }
};
